/**
 * US Spanish static labels.
 *
 * Typed `Record<MessageId, string>` against `en.ts`: omit a key and the build
 * fails with TS2741, add one that English does not have and it fails with an
 * excess-property error. That is the whole completeness guarantee.
 *
 * This file IS the translator handoff format for static labels — a bilingual
 * staffer edits it in a branch, PR review is the gate, `git blame` is the audit
 * trail. There is no TMS and no machine translation on this path: 20 keys of
 * app chrome is hours of work once, not a pipeline. The AI-assisted pipeline
 * exists for MENU CONTENT, which is 395 strings that churn — see
 * `docs/i18n-translation-pipeline.md`.
 */
import type { MessageId } from './en'

export const esUS: Record<MessageId, string> = {
  'avatar.sign-out': 'Cerrar sesión',

  'topbar.menu': 'Abrir navegación',
  'topbar.search': 'Buscar',
  'topbar.notifications': 'Notificaciones',
  'topbar.inbox': 'Bandeja de entrada',

  'search.placeholder': 'Buscar…',
  'search.empty': 'No se encontraron resultados.',
  'search.jumpTo': 'Ir a',

  'nav.shopping-list': 'Ingredientes',
  'nav.recipes': 'Recetas',
  'nav.deliverables': 'Entregables',

  'switcher.personal': 'Personal',
  'switcher.work': 'Trabajo',
  'switcher.family': 'Familia',
  'switcher.school': 'Escuela',
  'switcher.kitchen': 'Cocina',
  'switcher.account': 'Cuenta',
  'switcher.profile': 'Perfil',
  'switcher.billing': 'Facturación',

  'common.coming-soon.title': 'Próximamente',
  'common.coming-soon.body':
    'Todavía estamos construyendo esta vista. Vuelve después del próximo lanzamiento, o regresa a tu página de inicio mientras tanto.',
  'common.coming-soon.back-home': 'Ir al inicio',

  'calendar.noService': 'SIN SERVICIO',
  'calendar.halfDay': 'MEDIO DÍA',
  'calendar.aLaCarteSides': 'Se ofrecen acompañamientos a la carta',
  'calendar.milkSentence': 'Todas las comidas se sirven con leche a elegir ({options})',
  'calendar.continuation': ' (cont.)',
  'calendar.mealtimeMenuHeading': 'Menú de {mealtime}',
  'calendar.mealtimeJoin': ' y ',

  'calendar.dietary.vegetarian': 'Vegetariano',
  'calendar.dietary.vegan': 'Vegano',
  'calendar.dietary.glutenFree': 'Sin Gluten',
  'calendar.dietary.dairyFree': 'Sin Lácteos',
  'calendar.dietary.eggFree': 'Sin Huevo',

  'mealtime.breakfast': 'Desayuno',
  'mealtime.amSnack': 'Refrigerio de la Mañana',
  'mealtime.lunch': 'Almuerzo',
  'mealtime.snack': 'Refrigerio',
  'mealtime.pmSnack': 'Refrigerio de la Tarde',
  'mealtime.supper': 'Cena',

  'holiday.newYears': 'Año Nuevo',
  'holiday.martinLutherKing': 'Día de Martin Luther King Jr.',
  'holiday.presidents': 'Día de los Presidentes',
  'holiday.memorial': 'Día de los Caídos',
  'holiday.juneteenth': 'Juneteenth',
  'holiday.independence': 'Día de la Independencia',
  'holiday.labor': 'Día del Trabajo',
  'holiday.indigenousPeoples': 'Día de los Pueblos Indígenas',
  'holiday.veterans': 'Día de los Veteranos',
  'holiday.thanksgiving': 'Día de Acción de Gracias',
  'holiday.christmas': 'Navidad',
}
